goog.provide("shadow.js.shim.module$date_fns$locale$nb$default");
shadow.js.shim.module$date_fns$locale$nb$default = esm_import$date_fns$locale$nb.default;
